import { Accordion as MantineAccordion } from '@mantine/core';
import { ChevronDown } from 'lucide-react';

export const Accordion = MantineAccordion.extend({
	defaultProps: {
		variant: 'separated',
		chevron: <ChevronDown />,
		chevronSize: undefined,
	},
});
